import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';

import Card from 'components/Layout/Card';
import Table from 'components/Layout/Table';
import { fetchHistoryTemplateData } from 'store/slices';
import { getDataFromLocalStorage, objectToFormData } from 'utils/helpers';

// Mapping edited details codes to readable labels
const editedDetailMap = {
  "1": "Template Status",
  "2": "Email Subject",
  "3": "Email Body",
};

const EmailTemplateHistory = ({ template }) => {
  const dispatch = useDispatch();
  const userData = getDataFromLocalStorage();

  // Component state
  const [filterData, setFilterData] = useState({ total: 0, offset: 0, limit: 10 });
  const [isLoading, setIsLoading] = useState(true);
  const [templates, setTemplates] = useState([]);

  // Fetch template history
  const getHistoryTemplateData = async (params = {}) => {
    setIsLoading(true);

    const payload = { ...filterData, ...params, template_id: template?.id };
    const formData = objectToFormData(payload);
    const response = await dispatch(fetchHistoryTemplateData(formData));

    if (response?.data) {
      setTemplates(response.data.history || []);
      setFilterData((prev) => ({
        ...prev,
        ...params,
        total: response.data.result_count || 0,
      }));
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (template?.id) getHistoryTemplateData({ offset: 0 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [template?.id]);

  // Pagination handler
  const handleChangePagination = (offset) => getHistoryTemplateData({ offset });

  // Table header
  const header = [
    { title: 'Modified By', className: 'text-start' },
    { title: 'Date', className: 'text-start' },
    { title: 'Time', className: 'text-start' },
    { title: 'Edited Detail', className: 'text-start' },
  ];

  // Prepare row data
  const rowData = templates.map((elem) => {
    const { modified_by, date_and_time, edited_details, user_id } = elem;

    const formattedDate = moment(date_and_time).format("DD-MMM-YYYY");
    const formattedTime = moment(date_and_time).format("HH:mm");
    const formattedEditedDetail = Array.isArray(edited_details)
      ? edited_details.map((code) => editedDetailMap[String(code)] || code).join(", ")
      : edited_details
        ? editedDetailMap[String(edited_details)] || edited_details
        : "-";

    const formattedModifiedBy = user_id === userData?.id ? 'You' : modified_by || '-';

    const data = [
      { value: <span className="d-flex justify-content-start cps-10">{formattedModifiedBy}</span> },
      { value: <span className="d-flex justify-content-start cps-10">{formattedDate}</span> },
      { value: <span className="d-flex justify-content-start cps-10">{formattedTime}</span> },
      { value: <span className="text-truncate d-flex justify-content-start cps-10" title={formattedEditedDetail}>{formattedEditedDetail}</span> },
    ];

    return { data };
  });

  return (
    <Card className="cp-20">
      <div className="text-14-400-18 color-title-navy">Email Template Modified History :</div>

      <div className="cmt-16">
        <Table
          isLoading={isLoading}
          header={header}
          rowData={rowData}
          filterData={filterData}
          changeOffset={handleChangePagination}
          isOtherPagination
          customHeaderStyle={{
            backgroundColor: '#F3F4F8',
            color: '#171717',
            textAlign: 'left',
            paddingLeft: '15px',
          }}
        />
      </div>
    </Card>
  );
};

export default EmailTemplateHistory;
